module.exports = __webpack_public_path__ + "c305b04f5816c1a74ed5d984762f17b6.woff2";